import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Cabserviceinthane() {



const cardData = {
  keyword: " Cab Service in Thane",

headingDescription:
  "Omshree Cab provides reliable and comfortable cab service in Thane for travelers who need convenient and hassle‑free transportation within the city and nearby destinations. Whether you are planning airport transfers, corporate travel, local commuting, city sightseeing, family outings, or intercity trips, our cab service ensures a smooth and safe journey with professional drivers and well‑maintained vehicles. We offer flexible booking options including one‑way rides, round trips, hourly rentals, and full‑day packages with transparent pricing. Our fleet includes air‑conditioned sedans, spacious SUVs, luxury cars, and tempo travelers suitable for solo travelers, families, groups, and corporate clients. With punctual pickups from any location in Thane and 24/7 customer support, Omshree Cab is your trusted partner for dependable and affordable cab services in Thane.",

topPlaces: [
  {
    title: "Upvan Lake",
    description:
      "Upvan Lake is one of Thane’s most popular scenic spots, surrounded by lush green hills and peaceful walking paths. Visitors come here for morning strolls, boating, photography, and relaxation amidst nature. The area also hosts cultural and musical events throughout the year. Using a cab service in Thane makes it easy to reach Upvan Lake comfortably and enjoy quality time with family and friends without any transport worries."
  },
  {
    title: "Tikuji‑ni‑Wadi",
    description:
      "Tikuji‑ni‑Wadi is a well‑known amusement and water park in Thane, offering rides, attractions, and fun activities for visitors of all ages. The park is ideal for family outings, birthday celebrations, and group trips. Travelers can enjoy thrilling rides, water slides, and entertainment zones. Booking a cab provides hassle‑free transport to and from the park, ensuring a fun and comfortable day out."
  },
  {
    title: "Yeoor Hills",
    description:
      "Yeoor Hills is a serene hill station‑like destination in Thane known for its lush greenery, trekking trails, and panoramic views of the city. Nature lovers and adventure enthusiasts visit the area for hiking, photography, and picnics. A cab service makes it convenient to reach the hilltops and plan a relaxed nature retreat without worrying about navigation or parking."
  },
  {
    title: "Masunda Lake (Talav Pali)",
    description:
      "Masunda Lake, also called Talav Pali, is a beautiful lake in the heart of Thane where visitors enjoy boating, leisurely walks, and scenic views. The area around the lake features gardens, food stalls, and benches for relaxation. A cab ride allows comfortable access, especially for families and senior travelers, and makes it easy to combine the visit with other nearby sightseeing locations."
  },
  {
    title: "Kachrali Lake",
    description:
      "Kachrali Lake is another picturesque lake in Thane known for its tranquil surroundings and panoramic backdrop of the hills. Visitors come here for morning walks, meditation, and photography. Renting a cab provides easy access and flexibility to explore this serene spot while enjoying a peaceful day out in nature."
  },
  {
    title: "Gaimukh Lake",
    description:
      "Gaimukh Lake is a scenic natural attraction offering a peaceful environment and scenic views perfect for relaxation and photography. The surrounding greenery and open space make it an ideal spot for picnics and family time. A cab ride ensures comfortable travel from any part of Thane, allowing visitors to spend quality time without local transportation hassles."
  },
  {
    title: "Viviana Mall",
    description:
      "Viviana Mall is one of the largest and most popular shopping and entertainment centers in Thane, featuring retail stores, dining options, cinemas, and family entertainment zones. Visitors can shop, dine, and enjoy leisure activities in a vibrant indoor environment. A cab service provides convenient access, especially for group outings and weekend plans."
  },
  {
    title: "Shilonda Sports Village",
    description:
      "Shilonda Sports Village is a recreational area offering sports facilities, walking paths, and open green spaces for fitness enthusiasts and families. Visitors can enjoy sports activities, cycling, and outdoor games. Booking a cab allows easy transport to this location, making it ideal for fitness lovers and group outings."
  },
  {
    title: "Ghod Bandar Bridge Viewpoint",
    description:
      "The Ghod Bandar Bridge Viewpoint offers scenic views of the creek, bridge, and surrounding landscape, making it a nice spot for photography and sunset views. Visitors often come here to enjoy the peaceful atmosphere and watch the river flow. A cab ride ensures comfortable access to this viewpoint and flexibility to explore other nearby spots."
  },
  {
    title: "Kelva Beach",
    description:
      "Kelva Beach, located a short drive from Thane, is a serene seaside destination known for its calm waters, sandy shores, and relaxed vibe. Visitors can enjoy beach walks, picnics, and photography, especially during sunrise and sunset. Using a cab service makes it easy to plan a day trip to Kelva Beach from Thane and return comfortably without transport concerns."
  }
],



services: [
{
name: "Cab Service in Thane",
description: "Cab service in Thane provides reliable transportation for passengers traveling within the city and nearby destinations. Our fleet includes AC sedans, SUVs, and premium vehicles suitable for comfortable travel. Professional drivers ensure safe driving and punctual pickup services across Thane. Pickup services are available from homes, offices, hotels, railway stations, and nearby airport terminals. Ideal for daily commuting, business travel, and personal trips. Spacious interiors ensure comfortable seating during the journey. Flexible booking options allow passengers to schedule rides anytime. Reliable cab services ensure smooth and convenient transportation."
},
{
name: "Taxi Service in Thane",
description: "Taxi service in Thane offers dependable travel solutions for passengers needing transportation across the city and surrounding areas. Comfortable AC taxis ensure smooth travel through busy city roads and highways. Professional drivers ensure punctual pickup and safe driving services. Pickup services are available across residential areas, offices, hotels, and transport hubs in Thane. Ideal for business travel, tourism visits, and daily commuting. Spacious seating ensures comfortable journeys for passengers. Flexible ride scheduling allows convenient travel planning. Reliable taxi services ensure safe and stress-free transportation."
},
{
name: "Thane Cab Service",
description: "Thane cab service provides convenient transportation for passengers traveling within the city or to nearby locations. Our fleet includes modern AC sedans and SUVs designed for comfortable city travel. Professional drivers ensure safe driving and punctual pickup services. Pickup services are available from homes, offices, hotels, and railway stations across Thane. Ideal for daily commuting, airport transfers, and personal travel. Spacious interiors ensure comfortable seating during travel. Flexible booking options allow passengers to plan trips easily. Reliable cab services ensure smooth transportation experiences."
},
{
name: "Thane Taxi Service",
description: "Thane taxi service offers reliable travel options for passengers seeking comfortable transportation across the city. Our AC taxis ensure smooth journeys through city roads and highways. Professional drivers ensure punctual pickup and safe driving services. Pickup services are available across residential areas, offices, hotels, and railway stations in Thane. Ideal for business travel, tourism visits, and daily commuting. Spacious seating ensures comfortable travel for passengers. Flexible ride scheduling allows easy trip planning. Trusted taxi services ensure dependable city transportation."
},
{
name: "Cab Booking Thane",
description: "Cab booking in Thane allows passengers to reserve vehicles easily for local and outstation travel. Our fleet includes AC sedans and SUVs suitable for comfortable city journeys. Professional drivers ensure punctual pickup and safe driving services. Pickup services are available from homes, offices, hotels, railway stations, and nearby airport terminals. Ideal for business travel, tourism visits, and daily commuting. Spacious interiors ensure comfortable journeys for passengers. Flexible booking options allow quick ride scheduling. Reliable cab booking services ensure smooth transportation."
},
{
name: "Taxi Booking Thane",
description: "Taxi booking in Thane offers convenient reservations for passengers needing reliable transportation within the city. Our AC taxis ensure comfortable travel across busy city roads and highways. Professional drivers ensure punctual pickup and safe driving services. Pickup services are available across homes, offices, hotels, and railway stations in Thane. Ideal for business travel, personal trips, and tourism visits. Spacious seating ensures comfortable journeys for passengers. Flexible ride scheduling allows convenient travel planning. Reliable taxi booking services ensure hassle-free transportation."
},
{
name: "Thane Airport Cab Service",
description: "Thane airport cab service provides reliable transportation between Thane and nearby airport terminals. Comfortable AC sedans and SUVs ensure smooth travel for airport transfers. Professional drivers monitor flight schedules to ensure punctual pickup and drop services. Pickup services are available from homes, hotels, offices, and railway stations across Thane. Ideal for business travelers, tourists, and family travel. Spacious interiors ensure comfortable airport journeys. Flexible booking options allow advance ride reservations. Reliable airport cab services ensure stress-free transportation."
},
{
name: "Outstation Cab Service Thane",
description: "Outstation cab service in Thane offers dependable transportation for travelers planning trips outside the city. Our fleet includes AC sedans, SUVs, and premium vehicles suitable for highway travel. Professional drivers ensure safe driving and punctual arrival at destinations. Pickup services are available from homes, hotels, offices, and railway stations across Thane. Ideal for family vacations, pilgrimage tours, and weekend trips. Spacious interiors ensure comfortable long-distance journeys. Flexible one-way and round-trip options allow convenient planning. Reliable outstation cab services ensure smooth travel experiences."
},
{
name: "Thane to Mumbai Cab",
description: "Thane to Mumbai cab service offers convenient transportation for passengers traveling between the two cities. Comfortable AC vehicles ensure smooth travel through city roads and highways. Professional drivers ensure punctual pickup and safe driving services. Pickup services are available across Thane including homes, offices, hotels, and railway stations. Ideal for business travel, airport transfers, and daily commuting. Spacious seating ensures comfortable journeys for passengers. Flexible booking options allow convenient ride scheduling. Reliable cab services ensure efficient intercity transportation."
},
{
name: "Thane to Pune Cab",
description: "Thane to Pune cab service provides comfortable transportation for passengers traveling between the two cities. Our fleet includes AC sedans and SUVs suitable for highway journeys. Professional drivers ensure safe driving and punctual arrival at destinations. Pickup services are available across Thane including homes, offices, hotels, and railway stations. Ideal for business travel, tourism trips, and family visits. Spacious interiors ensure comfortable journeys during travel. Flexible one-way and round-trip options allow convenient planning. Reliable cab services ensure smooth intercity travel."
},
{
name: "Cheap Cab Service Thane",
description: "Cheap cab service in Thane offers affordable transportation for passengers seeking budget-friendly travel options. Our fleet includes economical AC sedans suitable for city journeys. Professional drivers ensure safe driving and punctual pickup services. Pickup services are available across residential areas, offices, hotels, and railway stations in Thane. Ideal for students, daily commuters, and budget travelers. Comfortable interiors ensure relaxed journeys during travel. Flexible booking options allow convenient ride scheduling. Affordable cab services ensure economical and reliable transportation."
},
{
name: "Best Taxi Service Thane",
description: "Best taxi service in Thane offers high-quality transportation solutions for passengers seeking reliable travel. Our fleet includes modern AC taxis and SUVs suitable for comfortable city travel. Professional drivers ensure punctual pickup and safe driving services. Pickup services are available across Thane including homes, offices, hotels, and railway stations. Ideal for business travel, tourism visits, and daily commuting. Spacious seating ensures comfortable journeys for passengers. Flexible ride scheduling allows convenient trip planning. Trusted taxi services ensure dependable transportation experiences."
}
],

tableData: [
["Cab Service in Thane","Taxi Service in Thane"],
["Thane Cab Service","Thane Taxi Service"],
["Cab Booking Thane","Taxi Booking Thane"],
["Thane Airport Cab Service","Outstation Cab Service Thane"],
["Thane to Mumbai Cab","Thane to Pune Cab"],
["Cheap Cab Service Thane","Best Taxi Service Thane"]
],



whychoose: [
  {
    WhyChooseheading: "Experienced Thane City Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in navigating Thane’s busy roads, highways, and nearby routes connecting Mumbai, Navi Mumbai, and other destinations. They ensure passengers reach their destination safely and on time."
  },
  {
    WhyChooseheading: "Transparent Taxi Pricing",
    WhyChoosedescription: "Omshree Cabs provides clear and transparent pricing for cab services in Thane. We explain per-kilometer fares, hourly packages, and travel costs in advance so customers never face hidden charges."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Our cab service in Thane is available 24 hours a day. Whether you need early morning airport transfers, late-night travel, or emergency transportation, Omshree Cabs is always available."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "Our fleet includes well-maintained and fully air-conditioned vehicles that are regularly cleaned and sanitized to provide a safe and comfortable ride."
  },
  {
    WhyChooseheading: "Flexible Cab Booking Options",
    WhyChoosedescription: "We offer a wide range of taxi services including local Thane rides, airport pickup and drop, outstation cab services, corporate travel, and hourly rental packages."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Omshree Cabs offers various vehicles including sedan cars, SUVs like Ertiga and Innova, and premium vehicles suitable for individuals, families, and business travelers."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Thane",
    WhyChoosedescription: "We provide convenient pickup from homes, offices, hotels, railway stations, and nearby areas across Thane for smooth and hassle-free travel."
  },
  {
    WhyChooseheading: "Trusted Cab Service in Thane",
    WhyChoosedescription: "Omshree Cabs is trusted by many customers for reliable taxi services in Thane. Our punctual drivers, clean vehicles, and professional service ensure a stress-free travel experience."
  }
]
};

const faqData = [
  { question: "Do you provide cab services in Thane?", answer: "Yes, Omshree Cabs provides reliable cab services in Thane for local travel, airport transfers, and outstation trips." },
  { question: "Is cab service available 24 hours in Thane?", answer: "Yes, our taxi service in Thane operates 24/7 for local rides, airport pickup, and long-distance travel." },
  { question: "Do you provide airport transfers from Thane?", answer: "Yes, we provide airport pickup and drop services from Thane to Mumbai Airport (Terminal 1 and Terminal 2)." },
  { question: "Which vehicles are available for booking?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, and premium vehicles depending on your travel requirements." },
  { question: "Do you provide outstation cabs from Thane?", answer: "Yes, we provide outstation cab services from Thane to destinations like Pune, Lonavala, Nashik, Surat, and many other cities." },
  { question: "Are the vehicles air-conditioned?", answer: "Yes, all vehicles provided by Omshree Cabs are fully air-conditioned for comfortable travel." },
  { question: "Can I book a cab online?", answer: "Yes, customers can easily book a cab online or through phone for quick confirmation." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during weekends, holidays, and peak travel seasons." },
  { question: "Do you provide corporate cab services in Thane?", answer: "Yes, we provide corporate cab services for business travel, meetings, and employee transportation." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to maintain hygiene and passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sandeep Patil",
    feedback:
      "Very reliable cab service in Thane. The driver arrived on time and the car was very clean and comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Priya Mehta",
    feedback:
      "Excellent taxi service in Thane. Smooth booking process and professional drivers made our airport trip very easy.",
    rating: 5
  }
];




















































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];











const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service in Thane",
  "description": "Omshree Cab provides reliable cab service in Thane for local travel, airport transfers, outstation trips, and intercity travel to Mumbai and Pune. Affordable fares, easy online booking, and trusted taxi service across Thane.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2800"
  }
};






  return (
    <div>
      
<Helmet>
  <title>Cab Service in Thane | Contact: +91 9892544084 | Omshree Cab</title>
  <meta 
    name="description" 
    content="Omshree Cab offers reliable cab service in Thane for local travel, airport, and outstation trips including Thane to Mumbai and Thane to Pune. Affordable fares and easy online taxi booking." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/41.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Cabserviceinthane;